import countryNamesSorted from './countriesFr.json';

/** Suisse, France, Italie en tête (formulaire membre), puis tous les pays par ordre alphabétique, puis Autre. */
const PRIORITY_COUNTRIES = ['Suisse', 'France', 'Italie'];

export const COUNTRIES = [
  ...PRIORITY_COUNTRIES,
  ...countryNamesSorted.filter((c) => !PRIORITY_COUNTRIES.includes(c)),
  'Autre',
];

/** Fait correspondre le libellé pays du profil à une entrée de la liste (casse, variantes). */
export function normalizeCountryForSelect(raw, list = COUNTRIES) {
  if (raw == null || raw === '') return '';
  const t = String(raw).trim();
  if (!t) return '';
  if (list.includes(t)) return t;
  const lower = t.toLowerCase();
  const found = list.find((c) => c.toLowerCase() === lower);
  if (found) return found;
  const aliases = {
    switzerland: 'Suisse',
    schweiz: 'Suisse',
    suisse: 'Suisse',
    italy: 'Italie',
    italia: 'Italie',
    france: 'France',
    frankreich: 'France',
    deutschland: 'Allemagne',
    germany: 'Allemagne',
    'république tchèque': 'Tchéquie',
    'republique tcheque': 'Tchéquie',
    'republique tchèque': 'Tchéquie',
    tchequie: 'Tchéquie',
    'tchèquie': 'Tchéquie',
    czechia: 'Tchéquie',
    'czech republic': 'Tchéquie',
    vatican: 'Saint-Siège',
    'vatican city': 'Saint-Siège',
    'holy see': 'Saint-Siège',
    taiwan: 'Taïwan',
    'taiwan, province of china': 'Taïwan',
    kosovo: 'Kosovo',
    palestine: 'Palestine',
    'palestinian territory': 'Palestine',
    'hong kong': 'Hong Kong',
  };
  if (aliases[lower]) {
    const mapped = aliases[lower];
    return list.includes(mapped) ? mapped : t;
  }
  return t;
}

// Cantons suisses (code + nom)
export const SWISS_CANTONS = [
  { value: 'AG', label: 'AG - Argovie' },
  { value: 'AI', label: 'AI - Appenzell Rhodes-Intérieures' },
  { value: 'AR', label: 'AR - Appenzell Rhodes-Extérieures' },
  { value: 'BE', label: 'BE - Berne' },
  { value: 'BL', label: 'BL - Bâle-Campagne' },
  { value: 'BS', label: 'BS - Bâle-Ville' },
  { value: 'FR', label: 'FR - Fribourg' },
  { value: 'GE', label: 'GE - Genève' },
  { value: 'GL', label: 'GL - Glaris' },
  { value: 'GR', label: 'GR - Grisons' },
  { value: 'JU', label: 'JU - Jura' },
  { value: 'LU', label: 'LU - Lucerne' },
  { value: 'NE', label: 'NE - Neuchâtel' },
  { value: 'NW', label: 'NW - Nidwald' },
  { value: 'OW', label: 'OW - Obwald' },
  { value: 'SG', label: 'SG - Saint-Gall' },
  { value: 'SH', label: 'SH - Schaffhouse' },
  { value: 'SO', label: 'SO - Soleure' },
  { value: 'SZ', label: 'SZ - Schwytz' },
  { value: 'TG', label: 'TG - Thurgovie' },
  { value: 'TI', label: 'TI - Tessin' },
  { value: 'UR', label: 'UR - Uri' },
  { value: 'VD', label: 'VD - Vaud' },
  { value: 'VS', label: 'VS - Valais' },
  { value: 'ZG', label: 'ZG - Zoug' },
  { value: 'ZH', label: 'ZH - Zurich' },
];

// Départements français (métropole + Corse + DOM)
export const FRENCH_DEPARTMENTS = [
  '01 - Ain', '02 - Aisne', '03 - Allier', '04 - Alpes-de-Haute-Provence', '05 - Hautes-Alpes',
  '06 - Alpes-Maritimes', '07 - Ardèche', '08 - Ardennes', '09 - Ariège', '10 - Aube',
  '11 - Aude', '12 - Aveyron', '13 - Bouches-du-Rhône', '14 - Calvados', '15 - Cantal',
  '16 - Charente', '17 - Charente-Maritime', '18 - Cher', '19 - Corrèze', '21 - Côte-d\'Or',
  '22 - Côtes-d\'Armor', '23 - Creuse', '24 - Dordogne', '25 - Doubs', '26 - Drôme',
  '27 - Eure', '28 - Eure-et-Loir', '29 - Finistère', '2A - Corse-du-Sud', '2B - Haute-Corse',
  '30 - Gard', '31 - Haute-Garonne', '32 - Gers', '33 - Gironde', '34 - Hérault',
  '35 - Ille-et-Vilaine', '36 - Indre', '37 - Indre-et-Loire', '38 - Isère', '39 - Jura',
  '40 - Landes', '41 - Loir-et-Cher', '42 - Loire', '43 - Haute-Loire', '44 - Loire-Atlantique',
  '45 - Loiret', '46 - Lot', '47 - Lot-et-Garonne', '48 - Lozère', '49 - Maine-et-Loire',
  '50 - Manche', '51 - Marne', '52 - Haute-Marne', '53 - Mayenne', '54 - Meurthe-et-Moselle',
  '55 - Meuse', '56 - Morbihan', '57 - Moselle', '58 - Nièvre', '59 - Nord',
  '60 - Oise', '61 - Orne', '62 - Pas-de-Calais', '63 - Puy-de-Dôme', '64 - Pyrénées-Atlantiques',
  '65 - Hautes-Pyrénées', '66 - Pyrénées-Orientales', '67 - Bas-Rhin', '68 - Haut-Rhin',
  '69 - Rhône', '70 - Haute-Saône', '71 - Saône-et-Loire', '72 - Sarthe', '73 - Savoie',
  '74 - Haute-Savoie', '75 - Paris', '76 - Seine-Maritime', '77 - Seine-et-Marne', '78 - Yvelines',
  '79 - Deux-Sèvres', '80 - Somme', '81 - Tarn', '82 - Tarn-et-Garonne', '83 - Var',
  '84 - Vaucluse', '85 - Vendée', '86 - Vienne', '87 - Haute-Vienne', '88 - Vosges',
  '89 - Yonne', '90 - Territoire de Belfort', '91 - Essonne', '92 - Hauts-de-Seine',
  '93 - Seine-Saint-Denis', '94 - Val-de-Marne', '95 - Val-d\'Oise',
  '971 - Guadeloupe', '972 - Martinique', '973 - Guyane', '974 - La Réunion', '976 - Mayotte',
].map(s => {
  const idx = s.indexOf(' - ');
  const value = idx >= 0 ? s.slice(0, idx).trim() : s;
  return { value, label: s };
});

// Provinces italiennes (sigla + nom)
export const ITALIAN_PROVINCES = [
  'AG - Agrigento', 'AL - Alessandria', 'AN - Ancona', 'AO - Aosta', 'AQ - L\'Aquila',
  'AR - Arezzo', 'AP - Ascoli Piceno', 'AT - Asti', 'AV - Avellino', 'BA - Bari',
  'BT - Barletta-Andria-Trani', 'BL - Belluno', 'BN - Benevento', 'BG - Bergamo', 'BI - Biella',
  'BO - Bologna', 'BZ - Bolzano', 'BS - Brescia', 'BR - Brindisi', 'CA - Cagliari',
  'CL - Caltanissetta', 'CB - Campobasso', 'CE - Caserta', 'CZ - Catanzaro', 'CH - Chieti',
  'CO - Como', 'CS - Cosenza', 'CR - Cremona', 'KR - Crotone', 'CN - Cuneo',
  'EN - Enna', 'FM - Fermo', 'FE - Ferrara', 'FG - Foggia', 'FC - Forlì-Cesena',
  'FR - Frosinone', 'GE - Genova', 'GO - Gorizia', 'GR - Grosseto', 'IM - Imperia',
  'IS - Isernia', 'SP - La Spezia', 'LT - Latina', 'LE - Lecce', 'LC - Lecco',
  'LO - Lodi', 'LU - Lucca', 'MC - Macerata', 'MN - Mantova', 'MS - Massa-Carrara',
  'MT - Matera', 'ME - Messina', 'MI - Milano', 'MO - Modena', 'MB - Monza e Brianza',
  'NA - Napoli', 'NO - Novara', 'NU - Nuoro', 'OR - Oristano', 'PD - Padova',
  'PA - Palermo', 'PR - Parma', 'PV - Pavia', 'PG - Perugia', 'PU - Pesaro e Urbino',
  'PE - Pescara', 'PC - Piacenza', 'PI - Pisa', 'PT - Pistoia', 'PN - Pordenone',
  'PZ - Potenza', 'PO - Prato', 'RG - Ragusa', 'RA - Ravenna', 'RC - Reggio Calabria',
  'RE - Reggio Emilia', 'RI - Rieti', 'RN - Rimini', 'RO - Rovigo', 'SA - Salerno',
  'SS - Sassari', 'SV - Savona', 'SI - Siena', 'SR - Siracusa', 'SO - Sondrio',
  'SU - Sud Sardegna', 'TA - Taranto', 'TE - Teramo', 'TR - Terni',
  'TO - Torino', 'TP - Trapani', 'TN - Trento', 'TV - Treviso', 'TS - Trieste',
  'UD - Udine', 'VA - Varese', 'VB - Verbano-Cusio-Ossola', 'VC - Vercelli', 'VR - Verona',
  'VV - Vibo Valentia', 'VI - Vicenza', 'VT - Viterbo',
].map(s => {
  const [value] = s.split(' - ');
  return { value: value.trim(), label: s };
});

/**
 * Provinces italienne (liste métier inscription) pour le lieu de naissance lorsque Pays = Italie.
 * Codes / libellés alignés carte d’identité et formulaires officiels ; l’adresse résidence utilise {@link ITALIAN_PROVINCES}.
 */
const ITALIAN_BIRTH_PROVINCE_NAMES = {
  AG: 'Agrigento',
  AL: 'Alessandria',
  AN: 'Ancona',
  AO: 'Aosta',
  AQ: "L'Aquila",
  AP: 'Ascoli-Piceno',
  AT: 'Asti',
  AV: 'Avellino',
  BA: 'Bari',
  BT: 'Barletta-Andria-Trani',
  BL: 'Belluno',
  BN: 'Benevento',
  BG: 'Bergamo',
  BI: 'Biella',
  BO: 'Bologna',
  BZ: 'Bolzano',
  BS: 'Brescia',
  BR: 'Brindisi',
  CA: 'Cagliari',
  CL: 'Caltanissetta',
  CB: 'Campobasso',
  CI: 'Carbonia Iglesias',
  CE: 'Caserta',
  CT: 'Catania',
  CZ: 'Catanzaro',
  CH: 'Chieti',
  CO: 'Como',
  CS: 'Cosenza',
  CR: 'Cremona',
  KR: 'Crotone',
  CN: 'Cuneo',
  EN: 'Enna',
  FM: 'Fermo',
  FE: 'Ferrara',
  FI: 'Firenze',
  FG: 'Foggia',
  FC: 'Forli-Cesena',
  FR: 'Frosinone',
  GE: 'Genova',
  GO: 'Gorizia',
  GR: 'Grosseto',
  IM: 'Imperia',
  IS: 'Isernia',
  SP: 'La-Spezia',
  LT: 'Latina',
  LE: 'Lecce',
  LC: 'Lecco',
  LI: 'Livorno',
  LO: 'Lodi',
  LU: 'Lucca',
  MC: 'Macerata',
  MN: 'Mantova',
  MS: 'Massa-Carrara',
  MT: 'Matera',
  VS: 'Medio Campidano',
  ME: 'Messina',
  MI: 'Milano',
  MO: 'Modena',
  MB: 'Monza-Brianza',
  NA: 'Napoli',
  NO: 'Novara',
  NU: 'Nuoro',
  OG: 'Ogliastra',
  OT: 'Olbia Tempio',
  OR: 'Oristano',
  PD: 'Padova',
  PA: 'Palermo',
  PR: 'Parma',
  PV: 'Pavia',
  PG: 'Perugia',
  PU: 'Pesaro-Urbino',
  PE: 'Pescara',
  PC: 'Piacenza',
  PI: 'Pisa',
  PT: 'Pistoia',
  PN: 'Pordenone',
  PZ: 'Potenza',
  PO: 'Prato',
  RG: 'Ragusa',
  RA: 'Ravenna',
  RC: 'Reggio-Calabria',
  RE: 'Reggio-Emilia',
  RI: 'Rieti',
  RN: 'Rimini',
  Roma: 'Roma',
  RO: 'Rovigo',
  SA: 'Salerno',
  SS: 'Sassari',
  SV: 'Savona',
  SI: 'Siena',
  SR: 'Siracusa',
  SO: 'Sondrio',
  TA: 'Taranto',
  TE: 'Teramo',
  TR: 'Terni',
  TO: 'Torino',
  TP: 'Trapani',
  TN: 'Trento',
  TV: 'Treviso',
  TS: 'Trieste',
  UD: 'Udine',
  VA: 'Varese',
  VE: 'Venezia',
  VB: 'Verbania',
  VC: 'Vercelli',
  VR: 'Verona',
  VV: 'Vibo-Valentia',
  VI: 'Vicenza',
  VT: 'Viterbo',
};

/** @type {{ value: string, label: string }[]} */
export const ITALIAN_BIRTH_PROVINCES = Object.entries(ITALIAN_BIRTH_PROVINCE_NAMES).map(([value, name]) => ({
  value,
  label: `${value} - ${name}`,
}));

const COUNTRY_NAMES_FOR_PROVINCE = {
  Suisse: SWISS_CANTONS,
  France: FRENCH_DEPARTMENTS,
  Italie: ITALIAN_PROVINCES,
};

/**
 * Retourne la liste des provinces/cantons/départements pour un pays donné,
 * ou null si le pays n'a pas de liste prédéfinie.
 */
export function getProvincesForCountry(countryName) {
  if (!countryName) return null;
  return COUNTRY_NAMES_FOR_PROVINCE[countryName] || null;
}

/**
 * Pour le lieu de naissance : cantons CH, départements FR, provinces IT (liste inscription).
 */
export function getBirthSubdivisionsForCountry(countryName) {
  if (!countryName) return null;
  if (countryName === 'Italie') return ITALIAN_BIRTH_PROVINCES;
  return getProvincesForCountry(countryName);
}

export function hasProvinceDropdown(countryName) {
  return countryName === 'Suisse' || countryName === 'France' || countryName === 'Italie';
}
